import styled from '@emotion/styled';
import Image from 'next/image';
import React from 'react';
import { nextImageTransitionProps } from '@/constants/next-image-transition-props';
const MainDiv = styled.div`
  width: 270px;
  height: 190px;
  transition: opacity 0.5s linear;
  :hover {
    cursor: pointer;
  }

  @media (max-width: 960px) {
    width: min(100%, 160px);
    height: auto;
  }
`;
const ArrowLabel = styled.p`
  margin: 0 5px 0 0;
  font-family: var(--font-work-sans), sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 136.8%;
  color: ${props => props.color};
  :hover {
    cursor: pointer;
  }

  @media (max-width: 960px) {
    font-size: 14px;
    text-align: center;
  }
`;
const Vector = styled.div`
  max-width: 225px;
  width: 100%;
  margin: 0 auto;

  @media (max-width: 960px) {
    max-width: 140px;
  }
`;
const ButtonDiv = styled.div`
  width: 100%;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: 960px) {
    justify-content: center;
  }
`;

export type GalaxyProps = {
  labelColor?: string;
  label?: string;
  vector?: string;
  opacity?: number;
};

const Galaxy = ({ label, labelColor, vector, opacity }: GalaxyProps) => {
  return (
    <MainDiv style={{ opacity: opacity }}>
      <Vector>
        <Image {...nextImageTransitionProps} src={vector!} alt="" />
      </Vector>
      <ButtonDiv>
        <ArrowLabel color={labelColor}>{label}</ArrowLabel>
        <svg
          width="18"
          height="16"
          viewBox="0 0 18 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginTop: 3 }}
        >
          <path
            d="M7.65653 0.176312C11.8479 0.176312 15.2457 3.57409 15.2457 7.76546C15.2457 11.9568 11.8479 15.3546 7.65653 15.3546C3.46516 15.3546 0.0673827 11.9568 0.0673825 7.76546C0.0673823 3.57409 3.46516 0.176312 7.65653 0.176312Z"
            fill="#4C3B51"
          />
          <path
            opacity="0.7"
            d="M6.76855 11.0856L10.0888 7.76581L6.76855 4.44556"
            stroke="#FDF3DE"
            strokeWidth="1.33926"
            strokeLinecap="round"
          />
        </svg>
      </ButtonDiv>
    </MainDiv>
  );
};

export default Galaxy;
